module.exports = __webpack_public_path__ + "25cd0f688f815bc4f6ac2b71eb6278ba.ttf";